import React from 'react';
import { FormattedMessage } from 'react-intl';

import css from './ListingPage.module.css';

const SectionDirectLinks = props => {
  const {
    onGoToDescription,
    onGoToSpecifications,
    onGoToEquipment,
    showDescription,
    showSpecifications,
    showEquipment,
  } = props;

  const links = [
    showDescription
      ? {
          key: 'description',
          onClick: onGoToDescription,
          labelId: 'SectionDirectLinks.description',
        }
      : null,
    showSpecifications
      ? {
          key: 'specifications',
          onClick: onGoToSpecifications,
          labelId: 'SectionSpecifications.title',
        }
      : null,
    showEquipment
      ? {
          key: 'equipment',
          onClick: onGoToEquipment,
          labelId: 'SectionDirectLinks.equipment',
        }
      : null,
  ].filter(Boolean);

  if (!links.length) {
    return null;
  }

  return (
    <div className={css.directLinks}>
      <div className={css.directLinksTitle}>
        <FormattedMessage id="SectionDirectLinks.title" />
      </div>
      <div className={css.directLinksItems}>
        {links.map((link, index) => (
          <React.Fragment key={link.key}>
            <button type="button" className={css.directLink} onClick={link.onClick}>
              <FormattedMessage id={link.labelId} />
            </button>
            {index < links.length - 1 ? (
              <span className={css.directLinksSeparator}>•</span>
            ) : null}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default SectionDirectLinks;
